export default {
    listagem: {
        titulo_pagina: 'Streaming List',
        table: {
            transmissao: "Streaming",
            resposta: "Response",
            mensagem: "Message",
            criadoem: "Created in",
            empty: "No Stream Found",
            visualizar: "View"
        }
    },
    show: {
        title: 'View Streaming'
    },
    form: {
        titulo_pagina: {
            criar: 'Create New Streaming',
            editar: 'Edit Streaming'
        },
        fields: {
            nome: {
                label: 'Name',
                description: 'State Name'
            },
            botao_salvar : 'Transmit Result'
        },
        create: {
            success: "Result transmitted successfully!",
            error: "Error transmitting result!"
        },
        update: {
            success: "Result successfully edited!",
            error: "Error editing result!"
        }
    },
    transmissao: {
        titulo_pagina: 'Report Exam to Interoperability',
        importacao_massa: 'Bulk Import',
        funcionalidade_contrucao: 'Functionality under Construction...',
        escolha_arquivo_importacao: 'Choose a file to import',
        arraste_solte_arquivo: 'Or drag and drop a file here',
        selecionar: 'Select',
        separador: 'Separator',
        arquivo_importacao_valores: {
            tab: 'Tab',
            pipe: 'Pipe',
            espaco: 'Space',
            virgula: 'Comma',
            ponto: 'Dot'
        },
        quantidade_coluna: 'Number of Columns',
        importar: 'Import',
        campos: {
            id_resultado_label: 'Result ID',
            id_resultado_descricao: 'Result ID',
            cpf_label: 'CPF',
            cpf_descricao: 'Patient CPF',
            nome_label: 'Name',
            nome_descricao: 'Patient Name',
            data_nascimento_label: 'Date of Birth',
            data_nascimento_descricao: 'Date of Birth',
            genero_label: 'Gender',
            genero_descricao: 'Patient Gender',
            genero_valores: {
                masculino: 'Male',
                feminino: 'Female'
            },
            endereco_label: 'Address',
            endereco_descricao: 'Patient Address',
            cep_label: 'Zip Code',
            cep_descricao: 'Zip Code',
            exame_label: 'Exam',
            resultado_label: 'Result',
            resultado_valores: {
                detectavel: 'Detectable',
                nao_detectavel: 'Undetectable',
                inconclusivo: 'Inconclusive',
            },
            amostra_biologica_label: 'Biological Sample',
            data_label: 'Date',
            data_descricao: 'Processing Date',
            uf_laboratorio_label: 'Laboratory State'
        },
        reporte_enviado: 'Report Sent! Check the list for Status',
        erro_reportar_exame: 'Error Reporting Exam'
    }    
}
